import { MessageWriter } from "../messages/MessageWriter";

export abstract class Validator 
{
  abstract validate( text:string ):boolean;
  messageWriter:MessageWriter;

  error( message:string )
  {
    if ( this.messageWriter )
    {
      this.messageWriter.error( message );
    }

    console.log( message );
  }
}